import { History } from "history";
import { toastError } from "@helpers/utils";
import { AppAsyncThunk } from "@/redux/hooks";
import { salesOrdersApi } from "./salesOrdersApi";

export const handleSaleOrderCopy = (
    saleOrderId: number,
    history: History
): AppAsyncThunk<boolean> => async (dispatch) => {
    if (!saleOrderId) {
        console.error("No sale order id provided");
        return false;
    }

    try {
        const saleOrder = await dispatch(
            salesOrdersApi.endpoints.getSaleOrder.initiate(saleOrderId, {
                subscribe: false,
            })
        ).unwrap();

        history.push("/dashboard/sales/orders/new", {
            copySaleOrder: saleOrder,
        });

        return true;
    } catch (e) {
        toastError(e);
        return false;
    }
};
